import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { formatImageUrl } from '../utils/imageUtils';

const SplashScreen = () => {
  const navigate = useNavigate();

  const { loading, user, getRedirectPath } = useAuth();

  useEffect(() => {
    // Wait for auth check to complete
    if (!loading) {
      const timer = setTimeout(() => {
        if (user) {
          navigate(getRedirectPath(user), { replace: true });
        } else {
          const onboardingCompleted = localStorage.getItem('onboarding_completed');
          if (onboardingCompleted === 'true') {
            navigate('/role-selection', { replace: true });
          } else {
            navigate('/onboarding', { replace: true });
          }
        }
      }, 2000); // Minimum 2s splash display

      return () => clearTimeout(timer);
    }
  }, [loading, user, navigate, getRedirectPath]);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-dark">
      {/* Logo */}
      <div className="mb-8 animate-fade-in">
        <img
          src={formatImageUrl("/logo.png")}
          alt="Dr. Vivara Logo"
          className="w-24 h-24 rounded-full mb-6 object-cover border-2 border-gold shadow-lg shadow-gold/20 mx-auto block transform hover:scale-110 transition-transform duration-500"
        />
        <h1 className="text-4xl font-bold bg-gradient-to-r from-gold via-yellow-200 to-gold bg-clip-text text-transparent text-center">
          Dr. Vivara
        </h1>
      </div>

      {/* Loading indicator */}
      <div className="flex space-x-2 mt-4">
        <div className="w-3 h-3 bg-gold rounded-full animate-bounce"></div>
        <div className="w-3 h-3 bg-gold rounded-full animate-bounce" style={{ animationDelay: '0.1s' }}></div>
        <div className="w-3 h-3 bg-gold rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
      </div>

      <p className="text-light text-center mt-8 text-sm">
        Your health is our priority
      </p>

      {/* Credit */}
      <div className="absolute bottom-10 left-0 right-0 text-center">
        <p className="text-gray-400 text-xs tracking-widest uppercase">Created by Phoenix</p>
      </div>
    </div>

  );
};

export default SplashScreen;